/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
    const valid_map = ['admin', 'editor']
    return valid_map.indexOf(str.trim()) >= 0
}

export function generateOptions(dataList) {
    var result = [];
    for (var i = 0; i < dataList.length; i++) {
        var param = dataList[i];
        param.key = param.id;
        if (param.parentId == "0") {
            var parent = param;
            if (getchilds(param.id, dataList).length > 0) {
                parent.children = getchilds(param.id, dataList);
            }
            result.push(parent);
        }
    }
    return result;
}

function getchilds(id, array) {
    let childs = [];
    for (var i = 0; i < array.length; i++) {
        var arr = array[i];
        if (arr.parentId == id) {
            childs.push(arr);
        }
    }
    for (var j = 0; j < childs.length; j++) {
        var child = childs[j];
        var childscopy = getchilds(child.id, array);
        if (childscopy.length > 0) {
            child.children = childscopy;
        }
    }
    return childs;
}


export function familyTree(arr1, id) {
    var temp = []
    var forFn = function (arr, id) {
        for (var i = 0; i < arr.length; i++) {
            var item = arr[i]
            if (item.id === id) {
                temp.unshift(item.id)
                forFn(arr1, item.parentId)
                break
            } else {
                if (item.children) {
                    forFn(item.children, id)
                }
            }
        }
    }
    forFn(arr1, id)
    return temp
}

//树形数组扁平化
export function flatTreeList(tree) {
    return tree.reduce((res, item) => {
        const { children, ...i } = item;
        return res.concat(i, children && children.length ? flatTreeList(children) : [])
    }, []);
}

/**
 * 四舍五入，保留指定小数位数，当原始数据不满足长度时，不要补 0
 * @param number [Number | String] 原始数据，支持字符串和数值型
 * @param i [Number] 保留的小数个数 >= 0
 * @returns [Number] 转换后的数据
 */
export function transformDecimal(number, i) {
    let decimalNum = null;
    let num = Number(number);
    if (!isNaN(num)) {
        let arr = num.toString().split(".");
        if (arr.length > 1 && arr[1].length > i) {
            let decimal = arr[1].slice(i, i + 1);
            // toFixed 有 bug，四舍六入五随机
            // 当四舍五入的数为 5，给其 + 1
            if (decimal === '5') {
                // 这里可能会存在 0.1 ** 5 = 0.000010000000000000003 但不影响四舍五入
                num += Math.pow(0.1, i + 1);
            }
            decimalNum = num.toFixed(i);
        }
        else {
            decimalNum = num;
        }
        decimalNum = Number(decimalNum);
    }
    return decimalNum;
}
